import React from 'react';

// Components
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './MeetingItemDetailPanelLoadingState.scss';

const MeetingItemDetailPanelLoadingState = () => {
  const baseClassName = 'MeetingItemDetailPanelLoadingState';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__header`}>
        <LoadingShimmer shape="square" width="32px" height="32px" />
      </div>
      <div className={`${baseClassName}__body`}>
        <LoadingShimmer shape="circle" width="24px" height="24px" />
        <div className={`${baseClassName}__body__content`}>
          <LoadingShimmer shape="rectangle" width="80%" height="24px" />
          <LoadingShimmer shape="rectangle" width="80%" height="24px" />
        </div>
      </div>
      <div className={`${baseClassName}__details`}>
        <div className={`${baseClassName}__details__item`}>
          <LoadingShimmer shape="rectangle" width="100px" height="24px" />
          <LoadingShimmer shape="rectangle" width="175px" height="24px" />
        </div>
        <div className={`${baseClassName}__details__item`}>
          <LoadingShimmer shape="rectangle" width="100px" height="24px" />
          <LoadingShimmer shape="rectangle" width="175px" height="24px" />
        </div>
      </div>
    </div>
  );
};

export default MeetingItemDetailPanelLoadingState;
